import { render, staticRenderFns } from "./MailingList.vue?vue&type=template&id=3b9583de&scoped=true&"
import script from "./MailingList.vue?vue&type=script&lang=js&"
export * from "./MailingList.vue?vue&type=script&lang=js&"
import style0 from "./MailingList.vue?vue&type=style&index=0&id=3b9583de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9583de",
  null
  
)

export default component.exports